<template>
  <div class="full-height full-width overflow-auto">
    <div :class="[gridRow ? 'grid-row' : 'wordspaces-grid']">
      <div class="grid-item full-width full-height" v-if="gridShowCreate">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="d-flex justify-center align-center flex-column"
            :elevation="hover ? 1 : 0"
            height="100%"
            outlined
            style="position: relative"
            tile
            width="100%"
            :disabled="loading"
            @click="$emit('click:create', $event)"
          >
            <slot name="grid-create-item">
              <div>
                <v-icon x-large>mdi-plus</v-icon>
              </div>
            </slot>
          </v-card>
        </v-hover>
      </div>
      <div
        v-for="item in items"
        :key="item[itemKey]"
        class="grid-item full-width full-height"
        :class="{
          'is-selected': selectObject[item[itemKey]],
        }"
        @click="toggleSelectItem(item)"
      >
        <v-card
          class="d-flex justify-end align-end flex-column"
          height="100%"
          outlined
          style="position: relative"
          width="100%"
          v-bind="eventItemClick(item)"
        >
          <slot :item="item" name="grid-item">
            <table-grid-item :headers="headers" :item="item">
              <template
                v-for="slot in slotItemHeader"
                v-slot:[slot]="{ header }"
              >
                <slot :header="header" />
              </template>
              <template
                v-for="slot in slotItemRow"
                v-slot:[slot]="{ item, header, value }"
              >
                <slot
                  :header="header"
                  :item="item"
                  :name="slot"
                  :value="value"
                />
              </template>
            </table-grid-item>
          </slot>
          <div class="selected-container">
            <span v-if="selectObject[item[itemKey]]" class="selected-label">
              {{ selectObject[item[itemKey]] }}
            </span>
          </div>
        </v-card>
      </div>
      <div v-show="loading" class="grid-item">
        <v-card
          class="d-flex justify-center align-center flex-column"
          height="100%"
          outlined
          width="100%"
        >
          <loading-component></loading-component>
        </v-card>
      </div>
      <div
        v-if="
          isScrollLoad &&
            !loading &&
            !pagination.isError &&
            pagination.hasMoreItems
        "
        v-intersect="onLoadMore"
        class="full-width"
        style="height: 5px"
      ></div>
    </div>
    <div
      v-if="
        !loading &&
          items.length < 1 &&
          !pagination.hasMoreItems &&
          !gridShowCreate
      "
      class="full-width"
    >
      <slot name="no-data">
        <div class="d-flex justify-center align-center">
          {{ $t('$vuetify.noDataText') }}
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import { BaseMixin, SelectMixin } from '../mixins'
import TableGridItem from './table-grid-item.vue'
export default {
  mixins: [SelectMixin, BaseMixin],
  components: { TableGridItem },
  props: {
    gridRow: Boolean,
    gridShowCreate: Boolean,
  },
  data: () => ({}),
  computed: {
    hasClickRow() {
      return this.$listeners && this.$listeners['click:row']
    },
  },
  methods: {
    eventItemClick(item) {
      let event = {}
      if (this.hasClickRow) {
        event['click:row'] = (e) => this.emit(e, 'click:row', item)
      }
      return event
    },
  },
}
</script>

<style scoped lang="scss">
.wordspaces-grid {
  display: grid;
  grid-row-gap: 12px;
  .grid-item {
    min-height: 150px;
    overflow: hidden;
  }
}
.grid-item:hover {
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%) !important;
}
.grid-row {
  grid-template-columns: 1fr !important;
  .grid-item {
    margin-bottom: 4px;
  }
}

@media only screen and (min-width: 1200px) {
  .wordspaces-grid {
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 12px;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1200px) {
  .wordspaces-grid {
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 12px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1024px) {
  .wordspaces-grid {
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 12px;
  }
}
@media only screen and (min-width: 720px) and (max-width: 992px) {
  .wordspaces-grid {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 12px;
  }
}
@media only screen and (min-width: 540px) and (max-width: 720px) {
  .wordspaces-grid {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 12px;
  }
}
@media only screen and (max-width: 540px) {
}
</style>

<style scoped>
.selected-container {
  position: absolute;
  left: 6px;
  top: 6px;
}
.selected-label {
  background-color: var(--v-primary-base);
  color: white;
  line-height: 20px;
  width: 20px;
  height: 20px;
  font-size: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
